
import React from 'react';
import {
  Box,
 
  Text,
  VStack,

} from '@chakra-ui/react';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';

export const ChannelPerformanceOverview = ({ data }) => {
    const categories = data.map(item => item.channel);
    const deliveredData = data.map(item => item.delivered);
    const readData = data.map(item => item.read);
  
    const chartOptions = {
      chart: {
        type: 'bar',
        height: 350,
      },
      title: {
        text: null,
      },
      xAxis: {
        categories: categories,
        title: {
          text: null,
        },
        lineColor: '#e5e7eb',
        tickColor: '#e5e7eb',
      },
      yAxis: {
        min: 0,
        max: 100,
        title: {
          text: null,
        },
        labels: {
          format: '{value}',
        },
        gridLineColor: '#f3f4f6',
      },
      legend: {
        align: 'center',
        verticalAlign: 'bottom',
      },
      plotOptions: {
        bar: {
          borderRadius: 4,
          pointWidth: 15,
          groupPadding: 0.1,
          pointPadding: 0.05,
        },
      },
      series: [
        {
          name: 'Delivered',
          data: data.map(item => item.delivery_rate),
          color: '#10b981',
        },
        {
          name: 'Read',
          data: data.map(item => item.read_rate),
          color: '#3b82f6',
        },
      ],
      credits: {
        enabled: false,
      },
      tooltip: {
        formatter: function() {
          const point = this.point;
          const index = this.point.index;
          const item = data[index];
          return `<b>${this.x}</b><br/>
                  ${this.series.name}: ${item.read.toLocaleString()} (${this.y.toFixed(1)}%)<br/>
                  Sent: ${item.sent.toLocaleString()}<br/>
                 
                   `;
        },
      },
    };
  
    return (
      <Box
        bg="white"
        p={6}
        borderRadius="lg"
        boxShadow="sm"
        border="1px solid"
        borderColor="gray.200"
      >
        <VStack align="stretch" spacing={4}>
          <Box>
            <Text fontSize="lg" fontWeight="semibold" mb={1}>
              Channel Performance Overview
            </Text>
            <Text fontSize="sm" color="gray.600">
              Performance metrics across all channels
            </Text>
          </Box>
  
          <Box mt={4}>
            <HighchartsReact highcharts={Highcharts} options={chartOptions} />
          </Box>
        </VStack>
      </Box>
    );
  };